module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_03 (2).b6393c6e.png";